import { PuckComponent } from '@measured/puck';

type RootProps = {
  children: React.ReactNode;

  title: string;
};

const createRootRenderer = () => {
  const Root: PuckComponent<RootProps> = ({ children }) => {
    return <div>{children}</div>;
  };

  return Root;
};

export { createRootRenderer };

export type { RootProps };
